import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Box, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

import {KS_STORE_PAGE_URL, KS_YELLOW_ROSE_STORE_PAGE_URL} from '../../../constants'
import useTagManager from '../../../hooks/use-tag-manager'
import PropTypes from 'prop-types'
import {useSiteContext} from '../../../contexts/site'

const Footer = ({hideNoSearchResults}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const tagManager = useTagManager()
    const {isYR} = useSiteContext()
    const {hostUrl} = commerceAPI.storefront
    const url = hostUrl + (isYR ? KS_YELLOW_ROSE_STORE_PAGE_URL : KS_STORE_PAGE_URL)

    return (
        <Box
            textAlign="center"
            borderTop={hideNoSearchResults ? '0px solid' : '1px solid'}
            borderColor="gray.550"
            paddingTop="20px"
        >
            <Link
                href={url}
                variant="underline"
                color="black.100"
                onClick={() => {
                    tagManager.directoryClick()
                }}
                fontSize="15px"
                fontWeight="400"
                lineHeight="20px"
                textUnderlineOffset="4px"
                letterSpacing="0.5px"
            >
                <FormattedMessage
                    id="select_store_modal.directory_of_stores"
                    defaultMessage="Directory of Stores"
                />
            </Link>
        </Box>
    )
}

Footer.propTypes = {
    hideNoSearchResults: PropTypes.any
}

export default Footer
